module.exports = __webpack_public_path__ + "img/Porto Apartment - 31 of 85.458ca0f3.jpeg";